import React, { useState } from 'react';
import { collection, getDocs, limit, query } from 'firebase/firestore';
import { db } from '../../firebase';

function TicketTestPage() {
    const [tickets, setTickets] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const fetchSampleTickets = async () => {
        setLoading(true);
        setError('');
        try {
            const ticketsQuery = query(collection(db, 'tickets'), limit(5));
            const querySnapshot = await getDocs(ticketsQuery);
            const ticketsList = [];
            querySnapshot.forEach((doc) => {
                ticketsList.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
            setTickets(ticketsList);
            if (ticketsList.length === 0) {
                setError('No tickets found in database');
            }
        } catch (err) {
            console.error('Error fetching tickets:', err);
            setError(`Error: ${err.message}`);
        }
        setLoading(false);
    };

    const generateQRData = (ticket) => {
        return JSON.stringify({
            ticketId: ticket.id,
            eventId: ticket.eventId,
            eventName: ticket.eventName,
            customerEmail: ticket.customerEmail,
            validationCode: ticket.id
        });
    };

    return (
        <div className="page" style={{ padding: '20px' }}>
            <h1>Ticket Test Page</h1>
            <p>Use this page to get sample ticket IDs and QR data for testing the validator.</p>
            
            <button 
                onClick={fetchSampleTickets}
                disabled={loading}
                style={{
                    padding: '10px 20px',
                    backgroundColor: '#007bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    marginBottom: '20px'
                }}
            >
                {loading ? 'Loading...' : 'Fetch Sample Tickets'}
            </button>

            {error && (
                <div style={{
                    padding: '10px',
                    backgroundColor: '#f8d7da',
                    color: '#721c24',
                    borderRadius: '5px',
                    marginBottom: '20px'
                }}>
                    {error}
                </div>
            )}

            {tickets.length > 0 && (
                <div>
                    <h2>Sample Tickets from Database:</h2>
                    {tickets.map((ticket, index) => (
                        <div key={ticket.id} style={{
                            border: '1px solid #ddd',
                            padding: '15px',
                            marginBottom: '15px',
                            borderRadius: '5px',
                            backgroundColor: '#f9f9f9'
                        }}>
                            <h3>Ticket #{index + 1}</h3>
                            <p><strong>Ticket ID:</strong></p>
                            <code style={{
                                display: 'block',
                                padding: '10px',
                                backgroundColor: '#fff',
                                border: '1px solid #ccc',
                                borderRadius: '3px',
                                marginBottom: '10px',
                                wordBreak: 'break-all'
                            }}>
                                {ticket.id}
                            </code>
                            
                            <p><strong>Event:</strong> {ticket.eventName || 'N/A'}</p>
                            <p><strong>Customer:</strong> {ticket.customerName || ticket.customerEmail || 'N/A'}</p>
                            <p><strong>Validated:</strong> {ticket.validated ? '✅ Yes' : '❌ No'}</p>
                            {ticket.validated && ticket.validatedAt && (
                                <p style={{ fontSize: '12px', color: '#666' }}>
                                    <strong>Validated at:</strong> {
                                        ticket.validatedAt.toDate ? 
                                        ticket.validatedAt.toDate().toLocaleString() : 
                                        new Date(ticket.validatedAt).toLocaleString()
                                    }
                                </p>
                            )}
                            
                            <details style={{ marginTop: '10px' }}>
                                <summary style={{ cursor: 'pointer', color: '#007bff' }}>
                                    Show QR Code Data (JSON)
                                </summary>
                                <pre style={{
                                    padding: '10px',
                                    backgroundColor: '#fff',
                                    border: '1px solid #ccc',
                                    borderRadius: '3px',
                                    marginTop: '10px',
                                    overflow: 'auto'
                                }}>
                                    {generateQRData(ticket)}
                                </pre>
                            </details>
                        </div>
                    ))}
                    
                    <div style={{
                        padding: '15px',
                        backgroundColor: '#d4edda',
                        color: '#155724',
                        borderRadius: '5px',
                        marginTop: '20px'
                    }}>
                        <h3>How to test:</h3>
                        <ol>
                            <li>Copy a Ticket ID from above</li>
                            <li>Go to the Ticket Validator page</li>
                            <li>Click "Show Test Mode"</li>
                            <li>Paste the Ticket ID and click Validate</li>
                            <li>Or use the QR scanner with a QR code containing the JSON data shown above</li>
                        </ol>
                    </div>
                </div>
            )}
        </div>
    );
}

export default TicketTestPage;
